import axiosInstance from ".";


export const getAllUsers = async () => {
    const response = await axiosInstance.get("/admin/supplier/users/users")
    return response;
}

export const getUserById = async (id) => {
    const response = await axiosInstance.get(`/users/${id}/profile`)
    return response;
}
export const updateUser = async (id, formData) => {
    const response = await axiosInstance.patch(`/users/${id}/profile`, formData)
    return response;
}
export const addUser = async (formData) => {
    const response = await axiosInstance.post(`/user/auth/register`, formData)
    return response;
}

export const deleteUser = async ({ userId }) => {
    const response = await axiosInstance.delete(`/admin/supplier/users/users/${userId}`)
    return response;
}

